import slider1 from '../../assets/slider1.webp';
import slider2 from '../../assets/slider2.webp';
import slider3 from '../../assets/slider3.webp';
import slider4 from '../../assets/slider4.webp';
import slider5 from '../../assets/slider5.webp';
import slider6 from '../../assets/slider6.webp';
import slider7 from '../../assets/slider7.webp';
import slider8 from '../../assets/slider8.webp';
import slider9 from '../../assets/slider9.webp';
import slider10 from '../../assets/slider10.webp';
import arrowLeft from '../../assets/arrowLeft.png';
import arrowRight from '../../assets/arrowRight.png';
import { Link } from 'react-router-dom';

export default function Projects() {
  const projects = [
    {
      id: '01',
      image: slider1,
      title: 'Cooperative AI-Powered Solidarity Monument',
      brand: 'Elidor',
      link: '/elidor2',
    },
    {
      id: '02',
      image: slider2,
      title: 'NFC-Enabled Card Station at Money 2020 Amsterdam',
      brand: 'papara',
      link: '/papara',
    },
    {
      id: '03',
      image: slider3,
      title: 'Play On | Dirt Is Good',
      brand: 'DIRT IS GOOD',
      link: '/omotwo',
    },
    {
      id: '04',
      image: slider4,
      title: '360° AR Portal Experience With OMO',
      brand: 'OMO',
      link: '/omo',
    },
    {
      id: '05',
      image: slider5,
      title: 'Elidor #WeSaidItsPossible  Metaverse Brand Launch',
      brand: 'Elidor',
      link: '/elidor',
    },
    {
      id: '06',
      image: slider6,
      title: 'AXE Relaxe Zone XR Experience',
      brand: 'Axe',
      link: '/axe',
    },
    {
      id: '07',
      image: slider7,
      title: 'Unilever’s Sustainable Living Plan 10ᵗʰ Year Anniversary',
      brand: 'Unilever',
      link: '/unilever',
    },
    {
      id: '08',
      image: slider8,
      title: 'Bristol Myers Squibb VR Experience to Anıtkabir',
      brand: 'Anıtkabir',
      link: '/anıtkabir',
    },
    {
      id: '09',
      image: slider9,
      title: 'Unilever Türkiye’s 100th Year of Republic Celebration',
      brand: 'Unilever Türkiye',
      link: '/unileverturkey',
    },
    {
      id: '10',
      image: slider10,
      title: 'Unilever Netherlands  Custom 3D Keepsakes',
      brand: 'Unilever Netherlands',
      link: '/unilevernl',
    },
  ];
  const scrollLeft = () => {
    document.getElementById('sliderContainer')?.scrollBy({
      left: -300,
      behavior: 'smooth',
    });
  };

  const scrollRight = () => {
    document.getElementById('sliderContainer')?.scrollBy({
      left: 300,
      behavior: 'smooth',
    });
  };

  return (
    <section className="w-full pt-12 md:pt-20" id="projects">
      {/* Üst Başlık ve Açıklama */}
      <div className="flex flex-row justify-between items-start max-w-7xl mx-auto px-6">
        {/* Projects Başlığı */}
        <h2
          className="font-questrial text-[#22282B] font-normal text-4xl md:text-6xl lg:text-[100px] leading-none w-1/2"
          style={{ lineHeight: 1 }}
        >
          Projects
        </h2>

        {/* Sağdaki açıklama */}
        <div className="w-1/2 text-right md:text-left">
          <h3 className="font-manrope text-[#22282B] text-2xl md:text-4xl font-medium leading-tight md:leading-[50px]">
            We Build Moments, Movements,
            <br className="hidden md:block" />
            And Media-First Executions.
          </h3>
          <p className="hidden md:block mt-6 md:mt-14 text-base md:text-xl font-manrope font-normal text-[#22282B]">
            Whether it lives online, on the streets, or across realities, our
            <br className="hidden md:block" />
            projects live where{' '}
            <span className="text-base md:text-xl font-bold">
              creativity, technology, and purpose collide.
            </span>
          </p>
        </div>
      </div>

      {/* Slider (Yatay Scroll) */}
      <div className="relative mt-24">
        {/* Sol Ok */}
        <button
          onClick={scrollLeft}
          className="hidden md:block absolute top-1/2 left-4 -translate-y-1/2 z-10 bg-white p-2 rounded-full shadow-md"
          aria-label="Sol kaydır"
        >
          <img src={arrowLeft} alt="Sol Ok" />
        </button>

        {/* Scroll Container */}
        <div
          id="sliderContainer"
          className="relative w-full"
          style={{
            overflowX: 'auto',
            overflowY: 'hidden',
            WebkitOverflowScrolling: 'touch',
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
            
          }}
        >
          <div className="inline-flex gap-x-4 md:gap-x-6 pl-6">
            {projects.map((proj, index) => (
              <div
                key={proj.id}
                className={`flex-shrink-0 w-[calc(60vw-1rem)] sm:w-[calc(50vw-1rem)] md:w-[300px] lg:w-[450px] ${
                  index % 2 === 1 ? 'mt-40 sm:mt-50 md:mt-60' : 'mt-0'
                }`}
              >
                {/* Sadece resim tıklanabilir olsun */}
                <Link to={proj.link} className="block rounded-2xl overflow-hidden shadow-md">
                  <img
                    src={proj.image}
                    alt={proj.title}
                    loading="lazy"
                    decoding="async"
                    className="w-full h-auto md:h-[600px] object-cover"
                  />
                </Link>

                {/* Başlık ve ID (tıklanamaz) */}
                <div className="mt-4">
                  <div className="flex items-center">
                    <span className="text-xl font-manrope font-medium text-[#22282B] flex-1 text-left pl-12">
                      {proj.id}
                    </span>
                    <h4 className="text-xl font-manrope text-[#22282B] flex-1 pr-4 text-right">
                      {proj.title}
                    </h4>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Sağ Ok */}
        <button
          onClick={scrollRight}
          className="hidden md:block absolute top-1/2 right-4 -translate-y-1/2 z-10 bg-black p-2 rounded-full shadow-md"
          aria-label="Sağ kaydır"
        >
          <img src={arrowRight} alt="Sağ Ok" />
        </button>
      </div>
    </section>
  );
}